import { Component, Input, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { UUID } from 'angular2-uuid';
import { icon, marker } from 'leaflet';
import { CookieService } from 'ngx-cookie-service';
import { UserService } from '../../../providers/user.service';
import { InvoiceUserListComponent } from '../../finance/invoice-user-list/invoice-user-list.component';
import { TransactionAccountListComponent } from '../../finance/transaction-account-list/transaction-account-list.component';
import { AccountLegalFormComponent } from '../../general/account-legal-form/account-legal-form.component';
import { AccountNaturalFormComponent } from '../../general/account-natural-form/account-natural-form.component';
import { ContactListComponent } from '../../general/contact-list/contact-list.component';
import { ConnectionListComponent } from '../../home/connection-list/connection-list.component';
import { ExtraComponent } from '../../home/extra/extra.component';
import { ItemComponent } from '../../home/item/item.component';
import { MessageTemplateComponent } from '../../home/message-template/message-template.component';
import { RenewComponent } from '../../home/renew/renew.component';
import { SlaComponent } from '../../home/sla/sla.component';
import { UploaderComponent } from '../../home/uploader/uploader.component';
import { FormComponent } from '../../shared/form/form.component';
import { ListComponent } from '../../shared/list/list.component';
import { ObjectViewerComponent } from '../../shared/object-viewer/object-viewer.component';
import { PingLogComponent } from '../../technical/ping-log/ping-log.component';
import { VoipUsagesComponent } from '../../home/voip-usages/voip-usages.component';

@Component({
  selector: 'app-user-list',
  templateUrl: '../../shared/base-list/base-list.component.html',
  styleUrls: ['./user-list.component.scss', '../../shared/base-list/base-list.component.scss']
})
export class UserListComponent extends ListComponent implements OnInit {

  constructor(
    public cookieService: CookieService,
    public activeModal: NgbModal,
    public titleService: Title,
    public translator: TranslateService,
    public service: UserService,
    public route: ActivatedRoute,
    public router: Router
  ) {
    super(cookieService, activeModal, titleService, translator, service, route, router);
    this.entity = 'user';
  }

  @Input('last_mac') last_mac: any;
  @Input('building_id') building_id: any;
  @Input('itself') itself: any;


  private _parent_id: number;
  public get parent_id(): number {
    return this._parent_id;
  }
  public set parent_id(v: number
  ) {
    this._parent_id = v;
    this.body.get_node_parent = v;

  }

  getBody(): any {
    const body = super.getBody();
    body['mode'] = 'list';
    body['get_node_parent'] = this.parent_id;

    if (this.selectedAccount && !this.itself) {
      const query = [
        ['reseller_id', '=', this.selectedAccount],
        'or',
        ['created_by', '=', this.selectedAccount]
      ];
      if (body.query) {
        body.query = [body.query, 'and', query];
      } else {
        body.query = query;
      }
    }
    return body;
  }

  async ngOnInit() {
    this.title = `users_${this.subentity}`;
    await super.ngOnInit();
  }

  async perform(action, row) {
    return new Promise(async (resolve, reject) => {
      try {
        switch (action.name) {
          case 'REFRESH':
            this.load();
            break;
          case 'TERMS':
            window.open(`https://www.petiak.com/service-policy.pdf`, 'service-policy')
            break;
          case 'ACCOUNT_ATTACHMENTS':
            const accountAttachs = this.activeModal.open(UploaderComponent, { size: 'xl' });
            accountAttachs.componentInstance.pkey = 'username';
            accountAttachs.componentInstance.path = 'account';
            accountAttachs.componentInstance.ref = row.account_id;
            break;
          case 'AGENT_ATTACHMENTS':
            const agentAttachs = this.activeModal.open(UploaderComponent, { size: 'xl' });
            agentAttachs.componentInstance.pkey = 'username';
            agentAttachs.componentInstance.path = 'account';
            agentAttachs.componentInstance.ref = row.agent_id;
            break;
          case 'SEND_MSG':
            const msgForm = this.activeModal.open(MessageTemplateComponent);
            msgForm.componentInstance.recipients = this.selectedRows || [row];
            msgForm.componentInstance.entity = 'USER';
            break;
          case 'CONTACT':
            const contactList = this.activeModal.open(ContactListComponent, { size: 'xl' });
            contactList.componentInstance.ref = row.account_id;
            break;
          case 'USAGE_REPORT':
            if (row.service_type === 'VOIP') {
              const voipUsage = this.activeModal.open(VoipUsagesComponent, { size: 'xl' });
              voipUsage.componentInstance.userid = row.username;
            } else {
              const radacctList = this.activeModal.open(ConnectionListComponent, { size: 'xl' });
              radacctList.componentInstance.userid = row.username;
              radacctList.componentInstance.serviceType = row.service_type;
            }
            break;
          case 'PING_LOG':
            const pingLogList = this.activeModal.open(PingLogComponent, { size: 'xl' });
            pingLogList.componentInstance.userid = row.username;
            break;
          case 'SLA':
            const slaComponent = this.activeModal.open(SlaComponent, { size: 'lg' });
            slaComponent.componentInstance.userid = row.username;
            break;
          case 'INVOICE_REPORT':
            const invoiceUserList = this.activeModal.open(InvoiceUserListComponent, { size: 'xl' });
            invoiceUserList.componentInstance.userid = row.username;
            break;
          case 'STATEMENT':
            const statementList = this.activeModal.open(TransactionAccountListComponent, { size: 'xl' });
            statementList.componentInstance.accountId = row.account_id;
            break;
          case 'NEW_USER_CHANGE':
            const userChangeForm = this.activeModal.open(FormComponent);
            userChangeForm.componentInstance.entityName = 'change';
            userChangeForm.componentInstance.formData.user_id = row.username;
            break;
          case 'NEW_USER_RULE':
            const userRuleForm = this.activeModal.open(FormComponent);
            userRuleForm.componentInstance.entityName = 'user_rule';
            userRuleForm.componentInstance.formData.username = row.username;
            break;
          case 'UPDATE_ACCOUNT':
            const editAccountForm = this.activeModal.open(
              row.person_type === 'N' ? AccountNaturalFormComponent : AccountLegalFormComponent, { size: 'lg' });
            editAccountForm.componentInstance.id = row.account_id;
            editAccountForm.componentInstance.isEdit = true;
            break;
          case 'UPDATE_AGENT':
            const editAgentForm = this.activeModal.open(AccountNaturalFormComponent, { size: 'lg' });
            editAgentForm.componentInstance.id = row.agent_id;
            editAgentForm.componentInstance.isEdit = true;
            break;
          case 'SEND_PASSWORD':
            await this.service.sendPassword(row.username, this.lang).toPromise();
            this.handleSuccess();
            break;
          case 'SET_PASSWORD':
            const changePasswordForm = this.activeModal.open(FormComponent, { size: 'sm' });
            changePasswordForm.componentInstance.colCount = 1;
            changePasswordForm.componentInstance.title = action.caption;
            changePasswordForm.componentInstance.hiddenApply = true;
            changePasswordForm.componentInstance.hiddenReset = true;
            changePasswordForm.componentInstance.fields = [
              {
                name: 'password',
                caption: this.translator.instant('PASSWORD'),
                value: row.service_type == 'VOIP' ? undefined : UUID.UUID().substr(0, 8),
                type: {
                  name: 'text',
                  readOnly: !(row.service_type == 'VOIP' || this.roles.includes('CR_SUP') || this.roles.includes('NOC_SUP')),
                },
                rules: [{ type: 'required' }]
              }
            ];
            changePasswordForm.componentInstance.done.subscribe((res) => {
              changePasswordForm.componentInstance.loading = true;
              this.service.setPassword(row.service_type, row.username, res.password).subscribe((res2: any) => {
                this.handleSuccess();
                changePasswordForm.componentInstance.loading = false;
                changePasswordForm.close();
              }, error => {
                this.handleError(error);
                changePasswordForm.componentInstance.loading = false;
              });
            });
            break;
          case 'BLOCK':
            const blockForm = this.activeModal.open(FormComponent, { size: 'sm' });
            blockForm.componentInstance.colCount = 1;
            blockForm.componentInstance.title = action.caption;
            blockForm.componentInstance.hiddenApply = true;
            blockForm.componentInstance.hiddenReset = true;
            blockForm.componentInstance.formData = { block_time: row.block_time }
            blockForm.componentInstance.fields = [
              {
                name: 'block_time',
                caption: this.translator.instant('BLOCK_TIME'),
                type: {
                  name: 'datetime'
                },
                rules: []
              }
            ];
            blockForm.componentInstance.done.subscribe((res) => {
              blockForm.componentInstance.loading = true;
              this.service.apiCall('api/user/block', { username: row.username, block_time: res.block_time }).subscribe(res3 => {
                this.handleSuccess();
                blockForm.componentInstance.loading = false;
                blockForm.close();
                this.load();
              }, error => {
                this.handleError(error);
                blockForm.componentInstance.loading = false;
              });

            });
            break;
          case 'OPEN_RADIO': {
            // Opened now, while the click still counts as a user gesture; an
            // open after the API answers is eaten by the popup blocker.
            const radioWindow = window.open('', '_blank');
            this.service.apiCall(`api/user/${action.name}`, { username: row.username }).subscribe((res: any) => {
              radioWindow.location.href = res.url;
            }, error => {
              radioWindow.close();
              this.handleError(error);
            });
            break;
          }
          case 'OPEN_PRTG':
            window.open(`https://prtg.petiak.ir`, '_blank');
            break;
          case 'SHOWPORT':
          case 'PORTINFO':
            this.showPortInfo(row, action);
            break;
          case 'CHANGEPROFILE':
            this.service.apiCall('api/user/showprofiles', { username: row.username }).subscribe((profiles: any) => {
              const changeProfileForm = this.activeModal.open(FormComponent, { size: 'sm' });
              changeProfileForm.componentInstance.colCount = 1;
              changeProfileForm.componentInstance.formData = {};
              changeProfileForm.componentInstance.title = action.caption;
              changeProfileForm.componentInstance.hiddenApply = true;
              changeProfileForm.componentInstance.hiddenReset = true;
              changeProfileForm.componentInstance.fields = [
                {
                  name: 'profile',
                  caption: this.translator.instant('PROFILE'),
                  value: profiles.current_user_profile ? profiles.current_user_profile :
                    row.adsl_data ? JSON.parse(row.adsl_data).current_user_profile : undefined,
                  type: {
                    name: 'select',
                    options: profiles.response.map(r => ({ value: r, name: r })),
                  },
                  rules: [{ type: 'required' }]
                }
              ];
              changeProfileForm.componentInstance.done.subscribe((res) => {
                changeProfileForm.componentInstance.loading = true;
                this.service.apiCall('api/user/changeprofile', { username: row.username, profile: res.profile }).subscribe(res3 => {
                  this.handleSuccess();
                  changeProfileForm.componentInstance.loading = false;
                  changeProfileForm.close();
                }, error => {
                  this.handleError(error);
                  changeProfileForm.componentInstance.loading = false;
                });
              });
            }, error => {
              reject(error);
              this.handleError(error);
            });
            break;
          case 'CHANGE_STATIC_IP_RANGE':
            this.service.apiCall('api/user/STATIC_IP_RANGES', { username: row.username }).subscribe((info: any) => {
              // \u2066...\u2069 keeps "a.b.c.x (n)" left-to-right inside the RTL form.
              const ltr = (s: string) => `\u2066${s}\u2069`;
              const rangeForm = this.activeModal.open(FormComponent);
              rangeForm.componentInstance.colCount = 1;
              rangeForm.componentInstance.formData = {};
              rangeForm.componentInstance.title = action.caption;
              rangeForm.componentInstance.hiddenApply = true;
              rangeForm.componentInstance.hiddenReset = true;
              rangeForm.componentInstance.fields = [
                {
                  name: 'current',
                  caption: this.translator.instant('CURRENT_STATIC_IP'),
                  value: ltr(info.current.exp_time
                    ? `${info.current.ip_address} (${new Date(info.current.exp_time).toLocaleDateString('fa-IR')})`
                    : info.current.ip_address),
                  type: { name: 'text', readOnly: true }
                },
                {
                  name: 'range',
                  caption: this.translator.instant('STATIC_IP_RANGE'),
                  type: {
                    name: 'select',
                    options: info.ranges.map(r => ({ value: r.range, name: ltr(`${r.range}.x (${r.free})`) })),
                  },
                  rules: [{ type: 'required' }]
                }
              ];
              rangeForm.componentInstance.done.subscribe((res) => {
                rangeForm.componentInstance.loading = true;
                this.service.apiCall('api/user/CHANGE_STATIC_IP_RANGE', { username: row.username, range: res.range }).subscribe(() => {
                  this.handleSuccess();
                  rangeForm.componentInstance.loading = false;
                  rangeForm.close();
                  this.load();
                }, error => {
                  this.handleError(error);
                  rangeForm.componentInstance.loading = false;
                });
              });
            }, error => {
              reject(error);
              this.handleError(error);
            });
            break;
          case 'TEMP_STATIC_IP':
            const tempIpForm = this.activeModal.open(FormComponent);
            tempIpForm.componentInstance.colCount = 1;
            tempIpForm.componentInstance.formData = { days: 1 };
            tempIpForm.componentInstance.title = action.caption;
            tempIpForm.componentInstance.hiddenApply = true;
            tempIpForm.componentInstance.hiddenReset = true;
            tempIpForm.componentInstance.fields = [
              {
                name: 'days',
                caption: this.translator.instant('DURATION'),
                value: 1,
                type: { name: 'number' },
                rules: [{ type: 'required' }, { type: 'range', min: 1, max: 30 }]
              }
            ];
            tempIpForm.componentInstance.done.subscribe((res) => {
              tempIpForm.componentInstance.loading = true;
              this.service.apiCall('api/user/TEMP_STATIC_IP', { username: row.username, days: res.days }).subscribe(() => {
                this.handleSuccess();
                tempIpForm.componentInstance.loading = false;
                tempIpForm.close();
                this.load();
              }, error => {
                this.handleError(error);
                tempIpForm.componentInstance.loading = false;
              });
            });
            break;
          case 'RENEW_SERVICE':
            this.service.apiCall('api/invoice/read', {
              fields: ['created_at'],
              query: [
                ['username', '=', row.username],
                'and',
                ['invoice_type', '=', 'S'],
                'and',
                ['status', '=', 'D']
              ],
              raw: true
            }).subscribe(old => {
              if (old.length) {
                this.router.navigate(['/sales/basket']);
              } else {
                const api = row.service_type !== 'VPS' ? 'api/invoice/addService' : 'api/invoice/addVps';
                const body = row.service_type !== 'VPS' ?
                  { account_id: this.selectedAccount, servicepriceid: row.service_price_id, username: row.username } :
                  { account_id: this.selectedAccount, vpspriceid: row.vps_price_id, username: row.username };
                this.service.apiCall(api, body).subscribe((result: any) => {
                  this.handleSuccess();
                  if (result[0][0].payable) {
                    this.router.navigate(['/sales/basket']);
                  }
                }, error => {
                  this.handleError(error);
                });
              }
            }, error => {
              this.handleError(error);
            });
            break;
          case 'BUY_CREDIT':
          case 'BUY_SERVICE':
          case 'CHANGE_SERVICE':
            const buyServiceForm = this.activeModal.open(RenewComponent, { size: 'xl' });
            buyServiceForm.componentInstance.user = row;
            buyServiceForm.componentInstance.done.subscribe(() => {
              buyServiceForm.close();
            });

            break;
          case 'BUY_EXTRA':
            const buyExtraForm = this.activeModal.open(ExtraComponent, { size: 'lg' });
            buyExtraForm.componentInstance.user = row;
            buyExtraForm.componentInstance.done.subscribe(() => {
              buyExtraForm.close();
            });

            break;
          case 'BUY_CHANNEL':
          case 'BUY_ITEM':
            const buyItemForm = this.activeModal.open(ItemComponent, { size: 'xl' });
            buyItemForm.componentInstance.user = row;
            buyItemForm.componentInstance.ip = false;
            buyItemForm.componentInstance.done.subscribe(() => {
              buyItemForm.close();
            });
            break;
          case 'BUY_STATIC_IP':
            const buyIpForm = this.activeModal.open(ItemComponent, { size: 'lg' });
            buyIpForm.componentInstance.user = row;
            buyIpForm.componentInstance.ip = true;
            buyIpForm.componentInstance.done.subscribe(() => {
              buyIpForm.close();
            });
            break;
          case 'SET_ALIAS':
            const setAliasForm = this.activeModal.open(FormComponent, { size: 'sm' });
            setAliasForm.componentInstance.colCount = 1;
            setAliasForm.componentInstance.title = action.caption;
            setAliasForm.componentInstance.fields = [
              {
                name: 'alias',
                caption: this.translator.instant('ALIAS'),
                value: row.alias,
                type: {
                  name: 'text',
                  rules: [{ type: 'stringLength', max: 100 }]
                }
              }
            ];
            setAliasForm.componentInstance.done.subscribe((res) => {
              setAliasForm.componentInstance.loading = true;
              this.service.setAlias(row.username, res.alias).subscribe(async res2 => {
                row.alias = res.alias;
                this.handleSuccess();
                setAliasForm.componentInstance.loading = false;
                setAliasForm.close();
                const menu = await this.service.menu(this.selectedAccount).toPromise();
                sessionStorage.setItem('menus', JSON.stringify(menu));
                window.location.reload();
              }, error => {
                this.handleError(error);
                setAliasForm.componentInstance.loading = false;
              });
            });

            break;
          case 'CHARGE_NGN':
            const chargeForm = this.activeModal.open(FormComponent, { size: 'sm' });
            chargeForm.componentInstance.colCount = 1;
            chargeForm.componentInstance.title = action.caption;
            chargeForm.componentInstance.fields = [
              {
                name: 'amount',
                caption: this.translator.instant('AMOUNT'),
                type: {
                  name: 'money',
                },
                rules: [{ type: 'required' }]
              },
              {
                name: 'days',
                caption: this.translator.instant('DURATION'),
                type: {
                  name: 'number',
                },
                rules: [{ type: 'required' }]
              }

            ];
            chargeForm.componentInstance.done.subscribe(async (res) => {
              chargeForm.componentInstance.loading = true;
              await super.perform(action, { username: row.username, amount: res.amount, days: res.days });
              this.handleSuccess();
              chargeForm.componentInstance.loading = false;
              chargeForm.close();
            });

            break;
          case 'CALL_MOBILE':
          case 'CALL_TEL':
            await this.service.perform('account', action.name, { username: row.account_id }).toPromise();
            resolve(true);
            break;
          case 'DYNAMIC_IP_ASSIGN':
            const assignIpForm = this.activeModal.open(FormComponent, { size: 'sm' });
            assignIpForm.componentInstance.colCount = 1;
            assignIpForm.componentInstance.title = action.caption;
            assignIpForm.componentInstance.hiddenApply = true;
            assignIpForm.componentInstance.hiddenReset = true;
            assignIpForm.componentInstance.fields = [
              {
                name: 'range',
                caption: this.translator.instant('RANGE'),
                type: {
                  name: 'text',
                  rules: [{ type: 'required' }, { "type": "stringLength", "min": 5, "max": 15 }]
                }
              }
            ];
            assignIpForm.componentInstance.done.subscribe((res) => {
              assignIpForm.componentInstance.loading = true;
              this.service.dynamicIPAssign(row.username, res.range).subscribe((res2: any) => {
                this.handleSuccess();
                assignIpForm.componentInstance.loading = false;
                assignIpForm.close();
              }, error => {
                this.handleError(error);
                assignIpForm.componentInstance.loading = false;
              });
            });
            break;
          case 'DEDICATE_INVOICE':
            const invoiceDedicateForm = this.activeModal.open(FormComponent, { size: 'sm' });
            invoiceDedicateForm.componentInstance.colCount = 1;
            invoiceDedicateForm.componentInstance.title = action.caption;
            invoiceDedicateForm.componentInstance.hiddenApply = true;
            invoiceDedicateForm.componentInstance.hiddenReset = true;
            invoiceDedicateForm.componentInstance.formData = { block_time: row.block_time }
            invoiceDedicateForm.componentInstance.fields = [
              {
                name: 'status',
                value: 'D',
                caption: this.translator.instant('TYPE'),
                type: {
                  name: 'select',
                  options: [
                    {
                      name: 'پیش فاکتور',
                      value: 'D'
                    },
                    {
                      name: 'فاکتور',
                      value: 'P'
                    }
                  ]
                },
                rules: [
                  {
                    type: 'required'
                  }
                ]
              },
              {
                name: 'timeframe_from',
                caption: this.translator.instant('TIMEFRAME_FROM'),
                type: {
                  name: 'datetime'
                },
                rules: [
                  {
                    type: 'required'
                  }
                ]
              },
              {
                name: 'timeframe_to',
                caption: this.translator.instant('TIMEFRAME_TO'),
                type: {
                  name: 'datetime'
                },
                rules: [

                ]
              }

            ];
            invoiceDedicateForm.componentInstance.done.subscribe((res) => {
              res.username = row.username;
              invoiceDedicateForm.componentInstance.loading = true;
              this.service.apiCall('api/user/dedicate_invoice', res).subscribe(res3 => {
                this.handleSuccess();
                invoiceDedicateForm.componentInstance.loading = false;
                invoiceDedicateForm.close();
                this.load();
              }, error => {
                this.handleError(error);
                invoiceDedicateForm.componentInstance.loading = false;
              });

            });
            break;
          case 'LAST_RADACCT':
            this.showLastRadacct(row, action);
            break;

          default:
            await super.perform(action, row);
            resolve(true);
        }
      } catch (error) {
        reject(error);
      }
    });
  }

  showPortInfo(row: any, action) {
    this.service.apiCall(`api/user/${action.name}`,
      {
        username: row.username,
        adsl_order_id: row.adsl_order_id
      }).subscribe((result: any) => {
        const showPortForm = this.activeModal.open(ObjectViewerComponent);
        showPortForm.componentInstance.title = action.caption;
        showPortForm.componentInstance.dir = 'ltr';
        showPortForm.componentInstance.obj = result;
      }, error => {
        this.handleError(error);
      });
  }

  showLastRadacct(row: any, action) {
    this.service.apiCall(`api/user/${action.name.toLowerCase()}`,
      {
        username: row.username
      }).subscribe((result: any) => {
        const form = this.activeModal.open(ObjectViewerComponent);
        form.componentInstance.title = action.caption;
        form.componentInstance.obj = result;
      }, error => {
        this.handleError(error);
      });
  }

  getMarker(i) {
    const size = 20; // + Math.sqrt(+i.bandwidth || 0);
    let status = '';
    switch (i.status) {
      case 'ACT':
        status = 'G';
        break;
      case 'EXP':
        status = 'Y';
        break;
      case 'REV':
        status = 'R';
        break;
      default:
        break;
    }
    const markr = marker([i.latitude || 35.783644, i.longitude || 51.440329], {
      title: i.username,
      riseOnHover: true,

      icon: icon({
        iconUrl: `assets/images/leaflet/marker_${status}.png`,
        iconSize: [size, size]
      })
    });
    // markr.bindPopup(`<a href="#/user/${i.username}" target="_blank">${i.username}</a>`);
    return markr;
  }

  setLocation(row: any, loc: any) {
    return new Promise((resolve, reject) => {
      row.latitude = loc.lat;
      row.longitude = loc.lng;
      this.service.apiCall('api/user/update',
        { username: row.username, latitude: loc.lat, longitude: loc.lng }).subscribe((result: any) => {
          resolve(result);
        }, error => {
          reject(error);
        });
    });
  }

  rowDoubleClick(e) {
    if ((this.selectedRows[0][this.accountField] || this.selectedRows[0][this.userField])
      && this.username !== this.selectedRows[0][this.accountField]) {
      this.chooseUser(this.selectedRows[0]);
    }
  }
}
